export const FETCH_QUESTIONS_SUCCESS = 'FETCH_QUESTIONS_SUCCESS';
export const FETCH_QUESTIONS_FAILURE = 'FETCH_QUESTIONS_FAILURE';
export const QUESTIONS_LOADING_MORE = 'QUESTIONS_LOADING_MORE';

export const FETCH_QUESTION_SUCCESS = 'FETCH_QUESTION_SUCCESS';
export const FETCH_QUESTION_FAILURE = 'FETCH_QUESTION_FAILURE';

export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';

export const POST_QUESTION_SUCCESS = 'POST_QUESTION_SUCCESS';
export const POST_QUESTION_FAILURE = 'POST_QUESTION_FAILURE';

export const LOADING_TRUE = 'LOADING_TRUE';
export const LOADING_FALSE = 'LOADING_FALSE';

export const NOTIFY_USER_TRUE = 'NOTIFY_USER_TRUE';
export const NOTIFY_USER_FALSE = 'NOTIFY_USER_FALSE';

export const AUTH_USER_SUCCESS = 'AUTH_USER_SUCCESS';
export const AUTH_USER_FAILURE = 'AUTH_USER_FAILURE';
export const AUTH_USER_LOGOUT = 'AUTH_USER_LOGOUT';

export const POST_ANSWER_SUCCESS = 'POST_ANSWER_SUCCESS';
export const POST_ANSWER_FAILURE = 'POST_ANSWER_FAILURE';

export const FETCH_PROFILE_SUCCESS = 'FETCH_PROFILE_SUCCESS';
export const FETCH_PROFILE_FAILURE = 'FETCH_PROFILE_FAILURE';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_FAILURE = 'UPDATE_PROFILE_FAILURE';

export const FETCH_USER_QUESTIONS_SUCCESS = 'FETCH_USER_QUESTIONS_SUCCESS';
export const FETCH_USER_QUESTIONS_FAILURE = 'FETCH_USER_QUESTIONS_FAILURE';
export const USER_QUESTIONS_LOADING_MORE = 'USER_QUESTIONS_LOADING_MORE';

export const FETCH_PINNED_QUESTIONS_SUCCESS = 'FETCH_PINNED_QUESTIONS_SUCCESS';
export const FETCH_PINNED_QUESTIONS_FAILURE = 'FETCH_PINNED_QUESTIONS_FAILURE';

export const QUESTION_ARCHIVED = 'QUESTION_ARCHIVED';
